var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"abstretch d-flex"},[_c('b-spinner',{staticClass:"w-100 h-100",attrs:{"variant":_vm.variant || 'light',"type":"grow"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }